import createApp from '@/create-app';
import { createClientAppContext } from '@/utils/context';
import { enableDebug, handleEditorAnchors } from '@sitecore-jss/sitecore-jss-vue';

import '@shared-jss/assets/scss/shared.scss';
import { APP_ROOT_ELEMENT } from './constants';

if (import.meta.env.VITE_DEBUG) {
    enableDebug(import.meta.env.VITE_DEBUG);
}

/*
  SSR Data
  If we're running in a server-side rendering scenario,
  the server will provide the window.__JSS_STATE__ object
  for us to acquire the initial state to run with on the client.

  This enables us to skip a network request to load up the layout data.

  SSR is initiated from /server/server.js.
*/
let __JSS_STATE__ = null;
const ssrRawJson = document.getElementById('__JSS_STATE__');

if (ssrRawJson) {
    __JSS_STATE__ = JSON.parse(ssrRawJson.innerHTML);
}

const initialState = __JSS_STATE__ || null;
const context = createClientAppContext();
const { app } = createApp(initialState, context);

app.mount(`#${APP_ROOT_ELEMENT}`);

handleEditorAnchors();
